import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import ClubeBotox from "../pages/clube-botox/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ClubeBotox />,
  },
  {
    path: "/clube-botox-2026",
    element: <ClubeBotox />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
